<template>
  <div>
    <van-popup v-model="visible" position="top">
      <Header title="用餐須知 Please Note" />
      <div class="main">
        <div v-html="gNl2br(sGetConfig('txtDiningInfo'))" />
      </div>
      <Footer b1="我知道了 OK" @b1c="close()" anime />
    </van-popup>

    <!-- 歡迎頁 -->
    <Welcome ref="rWelcome" />
  </div>
</template>

<style scoped>
.remark {
  margin: 0.3rem 0 0.3rem 0;
  line-height: 1.6rem;
}

.title {
  background-color: rgba(255, 255, 255, 0.95);
  font-size: 1.6rem;
  padding: 1rem;
  z-index: 999;
}

.van-popup {
  width: 100%;
  height: 100%;
}

.main {
  padding: 1rem;
  line-height: 2rem;
}
</style>

<script>
// import UserNote from "./Child/UserNote.vue";
// var fits = require("../../../../mixin/lib-fits-front");
export default {
  components: {
    // UserNote,
  },
  data() {
    return {
      visible: false,
      // obj: null,
      // preview: false,
      // itemnote: "",
      anime: false,
      // ordertmp: [],
      // rst: [],
      // beforeQty: 0,
    };
  },
  methods: {

    cmdWelcome() {
      this.$refs.rWelcome.show();
    },
    async show() {
      try {
        // console.log("show dining")
        this.visible = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.gClearLoading();
      }
    },
    close() {
      this.visible = false;
      this.cmdWelcome();
      // this.obj = null;
    },
  },
};
</script>
